<div class="container mt-4">
  <div class="row">
    <div class="col-sm-5 pt-3" style="background-color: #f67220">
      <form #forgotPasswordForm="ngForm" (ngSubmit)="submitForm()" novalidate>
        <div class="pt-5 pl-5">
          <h1>Forgot Password</h1>
          <div>
            <label for="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              [(ngModel)]="username"
              class="form-control"
              placeholder="Username"
              style="position: relative; padding-right: 30px"
            /><i
              class="fas fa-user"
              style="position: absolute; color: gray; top: 165px; right: 100px"
            ></i>
          </div>
          <div>
            <label for="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              [(ngModel)]="email"
              class="form-control"
              placeholder="Email"
              style="position: relative; padding-right: 30px"
            /><i
              class="fas fa-envelope"
              style="position: absolute; color: gray; top: 250px; right: 100px"
            ></i>
          </div>
          <div class="text-center">
            <button
              type="button"
              (click)="cancel()"
              style="
                background-color: #daa06d;
                font-weight: bold;
                margin-right: 25px;
              "
            >
              Cancel
            </button>
            <button
              type="submit"
              (click)="submitForm()"
              style="background-color: #ff5733; font-weight: bold"
            >
              Submit
            </button>
          </div>

          <div *ngIf="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
